// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"EditorDropdown_dropdownContainer__DH34v"};